import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "nprogress/nprogress.css";
import React from "react";
import { Provider } from "react-redux";
import { enableES5 } from "immer";
import store from "src/store";
import { SettingsProvider } from "src/contexts/SettingsContext";
import App from "src/App";
import "src/i18n";
import { createRoot } from "react-dom/client";

enableES5();

const rootContainer = document.getElementById("root");
const root = createRoot(rootContainer);

root.render(
    <Provider store={store}>
        <SettingsProvider>
            <App />
        </SettingsProvider>
    </Provider>
);
